<template>
  <div class="app">
    <v-card
      class="mx-auto"
      color="grey lighten-4"
      max-width="600"
    >
      <StatisticsGraph/>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
import StatisticsGraph from '@/components/StatisticsGraph.vue'

export default {
  name: 'statistics',
  components: {
    StatisticsGraph
  }
}
</script>
